import React from 'react'
import styled from '@emotion/styled'
import axios from 'axios'
import { useEffect } from 'react'
import { useState } from 'react'
import { AgendarStore } from '../AgendarStore'
import { format, parseISO } from 'date-fns'
import { Button } from 'antd'
import { webservicesBaseURL } from '../../../../App'
import useAxios from 'axios-hooks'
import { Show } from '../../../../components/common/Show'

const BoletoVencido = () => {
  const { Layout, GerarNovamente, ContainerButton, createBoleto } = BoletoVencido
  const { agendamento } = AgendarStore.useState()
  const dispatch = AgendarStore.useDispatch()
  const [loadingCreateAgendamento, setLoadingCreateAgendamento] = useState(false)

  const url = `${webservicesBaseURL}/boletos/${agendamento?.identificadorCobranca}`
  const [{ data: boleto, loading }] = useAxios(url)

  const handleCreateBoleto = () => {
    setLoadingCreateAgendamento(true)
    createBoleto(dispatch).finally(() => setLoadingCreateAgendamento(false))
  }

  return (
    <React.Fragment>
      <Show condition={loading}>Carregando informações...</Show>
      <Show condition={!loading}>
        <Layout>
          <div className="left-side">
            <h1 className="boleto-id">
              Boleto <strong>{boleto?.id}</strong>
            </h1>
          </div>

          <div className="right-side">
            <p className="boleto-date">
              Vencido em: <strong>{boleto ? formatDate(boleto?.dataVencimento) : ''}</strong>
            </p>
          </div>

          <div className="bottom">
            <span className="msg-click">A cobrança se encontra vencida.</span>
          </div>

          <ContainerButton className="btn-imprimir">
            <GerarNovamente
              loading={loadingCreateAgendamento}
              onClick={handleCreateBoleto}
              size="large"
              block
              type="primary"
            >
              Gerar nova cobrança
            </GerarNovamente>
          </ContainerButton>
        </Layout>
      </Show>
    </React.Fragment>
  )
}
BoletoVencido.Layout = styled.div`
  display: grid;
  gap: 20px;

  .left-side {
    grid-area: left-side;
  }
  .right-side {
    grid-area: right-side;
    align-items: center;
    justify-content: right;
  }
  .boleto-date {
    text-align: right;
    align-items: center;
  }
  .bottom {
    grid-area: bottom;
    text-align: center;
  }
  .msg-click {
    color: #666666;
  }
  .btn-imprimir {
    grid-area: btn-imprimir;
  }

  grid-template-columns: 1fr 1fr;

  grid-template-areas:
    'left-side right-side'
    'bottom bottom'
    'btn-imprimir btn-imprimir';
`
BoletoVencido.ContainerButton = styled.div`
  max-width: 600px;
  margin: 0 auto;
`
BoletoVencido.GerarNovamente = styled(Button)`
  width: 100%;
`
BoletoVencido.createBoleto = (dispatch: any) => {
  return dispatch(AgendarStore.thunks.createAgendamento())
}

const formatDate = (data: string) => {
  return format(parseISO(data), 'dd/MM/yyyy')
}

export default BoletoVencido
